type TermsCheckboxProps = {
  agreePrefix: string;
  linkText: string;
  linkHref: string;
};

export function TermsCheckbox({ agreePrefix, linkText, linkHref }: TermsCheckboxProps) {
  return (
    <div className="relative flex items-start">
      <input
        id="terms"
        name="terms"
        type="checkbox"
        required
        className="mt-0.5 size-4 cursor-pointer rounded border-gray-300 text-indigo-600 focus:ring-indigo-500"
      />
      <label htmlFor="terms" className="ml-3 inline cursor-pointer text-gray-700 text-sm">
        {agreePrefix}{' '}
        <a
          href={linkHref}
          target="_blank"
          rel="noopener noreferrer"
          className="font-medium text-indigo-600 hover:text-indigo-500"
        >
          {linkText}
        </a>
      </label>
    </div>
  );
}
